import React, {useEffect, useState} from "react";
import { Modal } from "react-bootstrap";
import {ModalProgressBar} from "../../../_partials/controls";

export function DeleteDialog({ show, onHide, handleDelete }) {

  const [isLoading, setIsloading] = useState(true);

  // if !id we should close modal
  useEffect(() => {
    setIsloading(false)
  }, []);

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >

      {isLoading && <ModalProgressBar />}

      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          حذف
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>آیا برای حذف کردن مطمئن هستید ؟</span>
        )}
        {isLoading && <span>در حال حذف ...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            انصراف
          </button>
          <> </>
          <button
            type="button"
            onClick={handleDelete}
            className="btn btn-primary btn-elevate"
          >
            حدف
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
